export default {
    create_eprescribe_heading: 'Create Digital Referral Script',
    create_eprescribe_content: 'Choose the criteria for your Digital Referral Script',
    steps: {
        step_1: 'Provider & Ancillary',
        step_2: 'Review',
        step_3: 'Patient information',
    },
    eprescribe_insurance: 'Patient insurance:',
    eprescribe_speciality: 'Patient speciality:',
    eprescribe_subspeciality: 'Patient subspeciality:',
    eprescribe_zip: 'Zip:',
    no_match: {
        physician: 'There are no providers that matches your criteria',
        ancillary: 'There are no providers that matches your criteria',
    },
}
